/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-select-visualizer-fr block)");
/* eslint-enable no-console */


(function () {
    // ── Données de base — plus de lignes et de pays ─────────────
    const ventes = [
        { id: 1, pays: "FR", annee: 2025, montant: 1200 },
        { id: 2, pays: "FR", annee: 2025, montant: 800 },
        { id: 3, pays: "FR", annee: 2024, montant: 300 },
        { id: 4, pays: "DE", annee: 2025, montant: 1500 },
        { id: 5, pays: "DE", annee: 2024, montant: 700 },
        { id: 6, pays: "DE", annee: 2025, montant: 900 },
        { id: 7, pays: "ES", annee: 2025, montant: 200 },
        { id: 8, pays: "ES", annee: 2025, montant: 300 },
        { id: 9, pays: "IT", annee: 2025, montant: 1800 },
        { id: 10, pays: "IT", annee: 2024, montant: 600 },

        { id: 11, pays: "US", annee: 2025, montant: 1100 },
        { id: 12, pays: "US", annee: 2025, montant: 700 },
        { id: 13, pays: "US", annee: 2024, montant: 500 },

        { id: 14, pays: "CA", annee: 2025, montant: 1300 },
        { id: 15, pays: "CA", annee: 2024, montant: 400 },

        { id: 16, pays: "GB", annee: 2025, montant: 1400 },
        { id: 17, pays: "GB", annee: 2025, montant: 600 },

        { id: 18, pays: "PT", annee: 2025, montant: 1600 },
        { id: 19, pays: "PT", annee: 2024, montant: 200 },

        { id: 20, pays: "SE", annee: 2025, montant: 950 },
        { id: 21, pays: "SE", annee: 2024, montant: 600 } // → total ≈ 950 (pas > 1000)
    ];

    function groupBy(data, col) {
        const m = new Map();
        data.forEach(r => {
            const k = r[col];
            if (!m.has(k)) m.set(k, { pays: k, count: 0, total: 0 });
            const g = m.get(k);
            g.count++;
            g.total += r.montant;
        });
        return [...m.values()];
    }

    const steps = [
        { key: "FROM", sql: "FROM ventes", desc: "Lire toutes les lignes de la table `ventes`.", action: (data) => data, showCols: ["id", "pays", "annee", "montant"] },
        { key: "WHERE", sql: "WHERE annee = 2025", desc: "Supprimer les lignes où `annee <> 2025`.", action: (data) => data.filter(r => r.annee === 2025), showCols: ["id", "pays", "annee", "montant"] },
        { key: "GROUP", sql: "GROUP BY pays", desc: "Regrouper les lignes par pays (`COUNT(*)`, `SUM(montant)`).", action: (data) => groupBy(data, "pays"), showCols: ["pays", "count", "total"] },
        { key: "HAVING", sql: "HAVING SUM(montant) > 1000", desc: "Éliminer les groupes dont la somme est ≤ 1000.", action: (data) => data.filter(g => g.total > 1000), showCols: ["pays", "count", "total"] },
        { key: "SELECT", sql: "SELECT pays, COUNT(*) AS nb, ...", desc: "Projeter les colonnes finales : `pays`, `nb` et `total`.", action: (data) => data.map(g => ({ pays: g.pays, nb: g.count, total: g.total })), showCols: ["pays", "nb", "total"] },
        { key: "ORDER", sql: "ORDER BY total DESC", desc: "Trier du total le plus élevé au plus bas.", action: (data) => [...data].sort((a, b) => b.total - a.total), showCols: ["pays", "nb", "total"] },
        { key: "LIMIT", sql: "LIMIT 5;", desc: "Renvoyer au plus 5 lignes.", action: (data) => data.slice(0, 5), showCols: ["pays", "nb", "total"] }
    ];

    let currentData = [...ventes];
    let curStepIdx = -1;

    function renderMini(data, cols) {
        const html = "<table class=\"mini\"><thead><tr>" +
            cols.map(c => `<th>${c}</th>`).join("") +
            "</tr></thead><tbody>" +
            data.map(r => `<tr>${cols.map(c => `<td>${r[c]}</td>`).join("")}</tr>`).join("") +
            "</tbody></table>";
        document.getElementById("step-table").innerHTML = html;
    }

    function updateStep(i) {
        curStepIdx = i;

        document.querySelectorAll(".sql-part").forEach(p => p.classList.remove("active"));
        const keyToId = {
            FROM: "part-from",
            WHERE: "part-where",
            GROUP: "part-group",
            HAVING: "part-having",
            SELECT: "part-select",
            ORDER: "part-order",
            LIMIT: "part-limit"
        };
        const id = keyToId[steps[i].key];
        if (id) document.getElementById(id).classList.add("active");

        let src = [...ventes];
        if (i > 0) {
            for (let j = 0; j < i; j++) {
                src = steps[j].action(src);
            }
        }
        currentData = steps[i].action(src);

        const before = src.length;
        const after = currentData.length;

        document.getElementById("step-meta").innerHTML =
            `<strong>Étape ${i + 1} – ${steps[i].sql}</strong><br>
                <span>Nombre de lignes: <strong>${before} avant</strong> → <strong>${after} après</strong></span>`;

        renderMini(currentData, steps[i].showCols);
    }

    function reset() {
        document.querySelectorAll(".sql-part").forEach(p => p.classList.remove("active"));
        curStepIdx = -1;
        currentData = [...ventes];
        document.getElementById("step-meta").textContent = "Cliquez sur un bouton pour avancer ou reculer dans l’exécution de la requête.";
        document.getElementById("step-table").innerHTML = "";
    }

    document.getElementById("btn-next").addEventListener("click", () => {
        if (curStepIdx < 6) {
            updateStep(curStepIdx + 1);
        }
    });

    document.getElementById("btn-prev").addEventListener("click", () => {
        if (curStepIdx > 0) {
            updateStep(curStepIdx - 1);
        }
    });

    document.getElementById("btn-reset").addEventListener("click", reset);
})()